export const borderVariants = {
  default: {
    borderRadius: "none",
  },
  pill: {
    borderRadius: "50px",
  },
  rounded: {
    borderRadius: "10px",
  },
};

